import { render, staticRenderFns } from "./TemplatesPicker.vue?vue&type=template&id=32ae57d6&scoped=true&"
import script from "./TemplatesPicker.vue?vue&type=script&lang=js&"
export * from "./TemplatesPicker.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesPicker.vue?vue&type=style&index=0&id=32ae57d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae57d6",
  null
  
)

export default component.exports